import type { Component, Entity2D } from '../../odie';
import { CornBlockProps } from '../defs/block';
import { CornBlockView } from '../views/blocks/CornBlockView';

export type CornBlockComponentOptions = {
  props: CornBlockProps;
};

export class CornBlockComponent implements Component {
  public static readonly NAME = 'blockCorn';
  public entity!: Entity2D;
  public view!: CornBlockView;

  public init(options: CornBlockComponentOptions): void {
    this.view = new CornBlockView(options.props);
  }
}
